<template>
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-body justify-content-center">
                    <div class="row">
                        <div class="col-12 col-lg-6 offset-lg-3">
                            <form class="without-steps my-3" action="/emarket/saveInfo.json" method="POST"
                                  @submit.prevent="processOrder">

                                <fieldset :disabled="requestInProcess == true">

                                    <fieldset v-if="userType == 'guest'">
                                        <div class="form-group row">
                                            <label class="col-sm-4 col-form-label">
                                                Тип плательщика
                                            </label>
                                            <div class="col-12 col-sm-8 align-self-center">
                                                <div class="row">
                                                    <div class="col-12 col-sm">
                                                        <div class="form-check form-check-inline">
                                                            <input class="form-check-input" type="radio"
                                                                   v-model="orderData.isLegalPerson" id="individual"
                                                                   :value="false"
                                                                   @click="resetOrganizationData"/>
                                                            <label class="form-check-label" for="individual">
                                                                Физическое лицо
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm">
                                                        <div class="form-check form-check-inline">
                                                            <input class="form-check-input" type="radio"
                                                                   v-model="orderData.isLegalPerson" id="legalPerson"
                                                                   :value="true"/>
                                                            <label class="form-check-label" for="legalPerson">
                                                                Юридическое лицо
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <hr/>

                                        <div class="form-group row">
                                            <label class="col-sm-4 col-form-label">
                                                Имя
                                                <sup class="text-danger"> *</sup>
                                            </label>
                                            <div class="col-12 col-sm-8 align-self-center">
                                                <input type="text" class="form-control" v-model="orderData.contactName"
                                                       required="required"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-4 col-form-label">
                                                Фамилия
                                                <sup class="text-danger"> *</sup>
                                            </label>
                                            <div class="col-12 col-sm-8 align-self-center">
                                                <input type="text" class="form-control"
                                                       v-model="orderData.contactSurname"
                                                       required="required"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-4 col-form-label">
                                                Контактный телефон
                                                <sup class="text-danger"> *</sup>
                                            </label>
                                            <div class="col-12 col-sm-8 align-self-center">
                                                <input type="text" class="form-control" v-model="orderData.contactPhone"
                                                       required="required"/>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <label class="col-sm-4 col-form-label">
                                                Наименование организации
                                                <sup class="text-danger" v-if="orderData.isLegalPerson == true"> *</sup>
                                            </label>
                                            <div class="col-12 col-sm-8 align-self-center">
                                        <textarea class="form-control" v-model="orderData.organizationName" rows="3"
                                                  :disabled="orderData.isLegalPerson == false"
                                                  :required="orderData.isLegalPerson == true"></textarea>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-4 col-form-label">
                                                ИНН организации
                                                <sup class="text-danger" v-if="orderData.isLegalPerson == true"> *</sup>
                                            </label>
                                            <div class="col-12 col-sm-8 align-self-center">
                                                <input type="text" class="form-control"
                                                       v-model="orderData.organizationInn"
                                                       :disabled="orderData.isLegalPerson == false"
                                                       :required="orderData.isLegalPerson == true"/>
                                            </div>
                                        </div>

                                        <hr/>
                                    </fieldset>

                                    <div class="form-group row">
                                        <div class="col-sm-4 col-form-label">
                                            Способ доставки
                                        </div>
                                        <div class="col-12 col-sm-8 align-self-center">
                                            <div class="row">

                                                <div class="col-12 col-sm" v-for="deliveryType in deliveryTypes"
                                                     v-bind:key="deliveryType.id">
                                                    <div class="form-check form-check-inline">
                                                        <input class="form-check-input" type="radio"
                                                               v-model="orderData.selectedDeliveryType"
                                                               :id="'delivery' + deliveryType.id"
                                                               :value="deliveryType"
                                                               @click="resetDeliveryData"
                                                        />
                                                        <label class="form-check-label"
                                                               :for="'delivery' + deliveryType.id">
                                                            {{deliveryType.name}}
                                                        </label>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-sm-4 col-form-label">
                                            Район доставки
                                            <sup class="text-danger"
                                                 v-if="orderData.selectedDeliveryType != null && orderData.selectedDeliveryType['type-class-name'] != 'self'">
                                                *</sup>
                                        </div>
                                        <div class="col-12 col-sm-8 align-self-center">
                                            <select class="form-control" v-model="orderData.selectedDeliveryRegion"
                                                    :disabled="orderData.selectedDeliveryType != null && orderData.selectedDeliveryType['type-class-name'] == 'self'"
                                                    :required="orderData.selectedDeliveryType != null && orderData.selectedDeliveryType['type-class-name'] != 'self'"
                                                    @change="setDeliveryPrice()">
                                                <option selected="selected" disabled="disabled"></option>
                                                <option v-for="deliveryRegion in deliveryRegions"
                                                        v-bind:key="deliveryRegion.id"
                                                        v-bind:value="deliveryRegion">
                                                    {{deliveryRegion.value}} -
                                                    {{calcItemDeliveryPrice(deliveryRegion) | formatPrice}} ₽
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-sm-4 col-form-label">
                                            Адрес доставки
                                            <sup class="text-danger"
                                                 v-if="orderData.selectedDeliveryType != null && orderData.selectedDeliveryType['type-class-name'] != 'self'">
                                                *</sup>
                                        </div>
                                        <div class="col-12 col-sm-8">
                                        <textarea class="form-control" v-model="orderData.deliveryAddress" rows="3"
                                                  :disabled="orderData.selectedDeliveryType != null && orderData.selectedDeliveryType['type-class-name'] == 'self'"
                                                  :required="orderData.selectedDeliveryType != null && orderData.selectedDeliveryType['type-class-name'] != 'self'"></textarea>
                                        </div>
                                    </div>

                                    <hr/>

                                    <div class="form-group row">
                                        <div class="col-sm-4 col-form-label">
                                            Способ оплаты
                                        </div>
                                        <div class="col-12 col-sm-8 align-self-center">
                                            <div class="row">
                                                <div class="col-12 col-sm" v-for="paymentType in paymentTypes"
                                                     v-bind:key="paymentType.id">
                                                    <div class="form-check form-check-inline">
                                                        <input class="form-check-input" type="radio"
                                                               v-model="orderData.selectedPaymentType"
                                                               :id="'payment' + paymentType.id"
                                                               :value="paymentType"/>
                                                        <label class="form-check-label"
                                                               :for="'payment' + paymentType.id">
                                                            {{paymentType.name}}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mt-5 mb-3">
                                        <div class="col-12">
                                            <dl class="row h5">
                                                <dt class="col">Сумма товаров в заказе</dt>
                                                <dd class="col text-right">
                                                    <strong>{{itemsTotalPrice | formatPrice}}&nbsp;₽</strong>
                                                </dd>
                                            </dl>
                                            <dl class="row h5">
                                                <dt class="col">Стоимость доставки</dt>
                                                <dd class="col text-right">
                                                    <strong>{{deliveryPrice | formatPrice}}&nbsp;₽</strong>
                                                </dd>
                                            </dl>
                                            <dl class="row h5 mt-3">
                                                <dt class="col">Итого</dt>
                                                <dd class="col text-right">
                                                    <strong>{{orderTotalPrice | formatPrice}}&nbsp;₽</strong>
                                                </dd>
                                            </dl>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-12">
                                            <button class="btn btn-primary btn-block" type="submit">
                                                Оформить заказ
                                            </button>
                                        </div>
                                    </div>
                                </fieldset>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'PurchaseFormComponent',
    props: {
      userType: {
        type: String,
        required: true,
        default: 'guest'
      }
    },
    data () {
      return {

        purchasingOneStepData : {},

        orderData: {
          isLegalPerson: false,

          contactName: '',
          contactSurname: '',
          contactPhone: '',

          organizationName: '',
          organizationInn: '',

          deliveryAddress: '',

          selectedDeliveryRegion: null,
          selectedDeliveryType: null,
          selectedPaymentType: null,
        },


        deliveryTypes: {},
        deliveryRegions: {},
        paymentTypes: {},
        requestInProcess: false,

        deliveryPrice: 0,
        itemsTotalPrice: 0,
      }
    },

    mounted () {
      let vm = this
      vm.initializePurchasingOneStep().then(response => {
        vm.purchasingOneStepData = response.data.onestep

        vm.initializeDeliveryTypes()
        vm.initializePaymentTypes()

        if(vm.userType == 'guest') {
          vm.initializeCustomer()
        }
      })


      vm.getDeliveryRegions()
      vm.getOrderPrice()
    },
    computed: {
      orderTotalPrice () {
        return this.itemsTotalPrice + this.deliveryPrice
      },
    },

    filters: {
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
      }
    },

    methods: {
      /**
       * Метод для запроса данных покупки в один шаг
       */
      initializePurchasingOneStep () {
        let vm = this
        return vm.getPurchasingOneStepData();
      },

      /**
       * Метод для инициализации типов доставки
       */
      initializeDeliveryTypes () {
        let vm = this

        vm.deliveryTypes = vm.purchasingOneStepData.delivery_choose.items.item
        vm.orderData.selectedDeliveryType = vm.deliveryTypes[0]
      },

      /**
       * Метод для инициализации способов оплаты
       */
      initializePaymentTypes () {
        let vm = this

        vm.paymentTypes = vm.purchasingOneStepData.payment.items.item
        vm.orderData.selectedPaymentType = vm.paymentTypes[0]
      },

      initializeCustomer () {
        let vm = this;

        vm.orderData.contactName = vm.purchasingOneStepData.customer.group[0].field[0].value;
        vm.orderData.contactSurname = vm.purchasingOneStepData.customer.group[0].field[1].value;

        vm.orderData.contactPhone = vm.purchasingOneStepData.customer.group[1].field[1].value;

        vm.orderData.isLegalPerson = (vm.purchasingOneStepData.customer.group[2].field[0].value == 1);
        vm.orderData.organizationName = vm.purchasingOneStepData.customer.group[2].field[1].value;
        vm.orderData.organizationInn = vm.purchasingOneStepData.customer.group[2].field[2].value;
      },

      /**
       * Метод для получения списка регионов доставки
       */
      getDeliveryRegions () {
        let vm = this
        axios.get('/udata://emarket/getDeliveryTariffs.json').then(response => {
          if (typeof(response.data.items.item) != 'undefined') {
            vm.deliveryRegions = response.data.items.item
          }
        })
      },

      /**
       * Метод для получения списка типов доставки
       */
      getPurchasingOneStepData () {
        let vm = this
        return axios.get('/udata://emarket/purchasing_one_step.json')
      },

      /**
       * Метод для получения суммы заказа
       */
      getOrderPrice () {
        let vm = this
        axios.get('/udata://emarket/cart.json').then(response => {
          vm.itemsTotalPrice = response.data.summary.price.actual
        })
      },

      /**
       * Метод для установки стоимости доставки
       */
      setDeliveryPrice () {
        let vm = this

        if(vm.itemsTotalPrice < vm.orderData.selectedDeliveryRegion.discountPrice) {
          vm.deliveryPrice = vm.orderData.selectedDeliveryRegion.price
        } else {
          vm.deliveryPrice = 0
        }
      },

      /**
       * Метод для очистки выбранного способа доставки и стоимости
       */
      resetDeliveryData () {
        let vm = this
        vm.orderData.selectedDeliveryRegion = null
        vm.deliveryPrice = 0
      },

      /**
       * Метод для очистки данных об организации
       */
      resetOrganizationData () {
        let vm = this
        vm.orderData.organizationName = ''
        vm.orderData.organizationInn = ''
      },

      /**
       * Метод для расчета стоимости доставки для переданного района
       */
      calcItemDeliveryPrice (currentDeliveryRegion) {
        return this.itemsTotalPrice >= currentDeliveryRegion.discountPrice ? 0 : currentDeliveryRegion.price
      },

      /**
       * Метод для отправки данных заказа на сервер
       */
      processOrder () {
        let vm = this

        vm.requestInProcess = true;

        axios.post('/emarket/customSaveInfo.json', {
          orderData: vm.orderData,
        }).then(response => {
          vm.requestInProcess = false;
          if(typeof(response.data.redirectUrl) != 'undefined') {
            window.location = response.data.redirectUrl
          }
        })

      },
    },
  }
</script>

<style scoped></style>